import React from "react";
import { useHistory } from "react-router-dom";
import {motion} from "framer-motion";
import {useSelector} from 'react-redux'
import Education from './Education'
import Work from './Work'
import Project from './Project'
import AddInfo from './AddInfo'
import Lang from './Lang'
import Interest from './Interest'
import Skill from './Skill'

const contVariant={
  hidden:{
    opacity:0
  },
  visible:{
    opacity:1,
    transition:{
      duration:0.5
    }
  }
}
const linkVariant={
  hover:{
    textShadow: "2px 2px 10px rgba(0,0,0,0.8)",
    boxShadow:"2px 2px 10px rgba(0,0,0,0.8)",
    transition:{
      duration:0.2
    }
  }
}
export default function Preview() {
	const history = useHistory();
	const resumeData=useSelector(states=>states.resumeData)
	const {
    name,
    designation,
    address,
    email,
    contact,
    education:educations,
    skills,
    langKnown:langs,
    workExp:works,
    projects,
    interests,
    addInfo:addInfos,
    intro
  }=resumeData;
  	function saveData(){
  		localStorage.setItem("resumeData",JSON.stringify(resumeData))
  		history.push("/choose-resume-template")
  	}
  return (
    <motion.div className="container" style={{flexDirection:"column"}} exit={{opacity:0}}>
    <motion.div className="preview"
        variants={contVariant}
        initial="hidden"
        animate="visible"
    >
      <h1 style={{margin:"10px auto",textAlign:"center"}}>Preview Details</h1>
      <div className="data">
      	<div className="personal-info">
      		<h2 className="label-head"><i class="mr-2 fas fa-user"></i>Personal details<span onClick={()=>history.push("/personal-info")} className="edit-icon-style"><i class="fas fa-user-edit"></i></span></h2>
      		<div className="content">
      			<h3>{name}</h3>
      			<h5>({designation})</h5>
      			<p>{address} <br/> {contact}</p>
      			<span><a href="mailto:">{email}</a></span>
      		</div>
      	</div>
      	<div className="intro-info">
      		<h2 className="label-head"><i class="fas fa-portrait mr-2"></i>Introduction<span onClick={()=>history.push("/introduction")} className="edit-icon-style"><i class="fas fa-edit"></i></span></h2>
      		<div className="content">
      			<p>{intro}</p>
      		</div>
      	</div>
      	<div className="education-info">
			<h2 className="label-head"><i class="mr-2 fas fa-university"></i>Education details<span onClick={()=>history.push("/education-details")} className="edit-icon-style"><i class="fas fa-edit"></i></span></h2>
        	<ul>
        	  {educations.map((education,index)=>{
        	    return (<Education education={education} key={index} id={index} />)
        	  })}
        	</ul>
      	</div>
      	<div className="skill-info">
      		<h2 className="label-head"><i class="mr-2 fas fa-code"></i>Skills<span onClick={()=>history.push("/add-skills")} className="edit-icon-style"><i class="fas fa-edit"></i></span></h2>
        	<ul>
        	  {skills.map((skill,index)=>{
        	    return (<Skill skill={skill} key={index} id={index} />)
        	  })}
        	</ul>
      	</div>
      	<div className="lang-info">
      		<h2 className="label-head"><i class="mr-2 fas fa-language"></i>Languages known<span onClick={()=>history.push("/add-languages")} className="edit-icon-style"><i class="fas fa-edit"></i></span></h2>
        	<ul>
        	  {langs.map((lang,index)=>{
        	    return (<Lang lang={lang} key={index} id={index} />)
        	  })}
        	</ul>
      	</div>
      	<div className="work-info">
      		<h2 className="label-head"><i class="mr-2 fas fa-briefcase"></i>Work experience<span onClick={()=>history.push("/add-work-experience")} className="edit-icon-style"><i class="fas fa-edit"></i></span></h2>
        	<ul>
        	  {works.map((work,index)=>{
        	    return (<Work work={work} key={index} id={index} />)
        	  })}
        	</ul>
      	</div>
      	<div className="project-info">
      		<h2 className="label-head"><i class="mr-2 fas fa-tasks"></i>Projects<span onClick={()=>history.push("/add-project-details")} className="edit-icon-style"><i class="fas fa-edit"></i></span></h2>
        	<ul>
        	  {projects.map((project,index)=>{
        	    return (<Project project={project} key={index} id={index} />)
        	  })}
        	</ul>
      	</div>
      	<div className="interest-info">
      		<h2 className="label-head"><i className="fas fa-book-reader mr-2"></i>Interests<span onClick={()=>history.push("/add-interests")} className="edit-icon-style"><i class="fas fa-edit"></i></span></h2>
        	<ul>
        	  {interests.map((interest,index)=>{
        	    return (<Interest interest={interest} key={index} id={index} />)
        	  })}
        	</ul>
      	</div>
        <div className="additional-info">
          <h2 className="label-head"><i className="fas fa-info-circle mr-2"></i>Additional Info<span onClick={()=>history.push("/additional-details")} className="edit-icon-style"><i class="fas fa-edit"></i></span></h2>
          <ul>
            {addInfos.map((addInfo,index)=>{
              return (<AddInfo addInfo={addInfo} key={index} id={index} />)
            })}
          </ul>
        </div>
      </div>
      <motion.button variants={linkVariant} whileHover="hover" className="save-btn" onClick={saveData}>Save & Continue</motion.button>
    </motion.div>
    </motion.div>
  );
}
